import { Component } from "react";
import {
    Card,
    Button,
    Row,
    Col,
    Form,
    Alert,
    Badge,
    Modal,
    Spinner,
} from "react-bootstrap";
import {
    FaPlus,
    FaTrash,
    FaArrowUp,
    FaArrowDown,
    FaCheck,
    FaEye,
} from "react-icons/fa";
import { withRouter } from "../../common/with-router";
import api from "../../services/api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AsyncSelect from "react-select/async";
import { carregarTiposEventos } from "../../services/eventosForm";

// Tipos de campos disponíveis

// Tipos de campos disponíveis
const TIPOS_CAMPOS = [
    { value: "text", label: "Texto" },
    { value: "textarea", label: "Área de Texto" },
    { value: "radio", label: "Escolha Única (Radio)" },
    { value: "select", label: "Seleção (Dropdown)" },
    { value: "checkbox", label: "Múltipla Escolha (Checkbox)" },
    { value: "date", label: "Data" },
    { value: "file", label: "Arquivo" },
];

class FormulariosEventosEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            saving: false,
            formulario_id: null,
            titulo_pagina: "Novo Formulário",
            
            // Dados do formulário
            nome: "",
            evento: "onApproveLaudo",
            programa: null,
            titulo_modal: "",
            descricao: "",
            ativo: true,
            campos: [],
            
            // Modal de campo
            showCampoModal: false,
            campoEditIndex: null,
            campoEdit: this.getCampoVazio(),
            
            // Preview
            showPreviewModal: false,
            
            erro: "",
            eventosDisponiveis: [],
        };
    }

    getCampoVazio = () => ({
        slug: "",
        label: "",
        tipo: "text",
        obrigatorio: false,
        placeholder: "",
        observacao: "",
        opcoes: [],
        extensoes: ".pdf,.jpg,.jpeg,.png",
    });

    componentDidMount() {
        this.carregarDadosIniciais();
        const id = this.props.router.params.id;

        if (id) {
            this.setState({
                formulario_id: id,
                titulo_pagina: "Editar Formulário",
                loading: true,
            });
            this.carregarFormulario(id);
        }
    }

    carregarDadosIniciais = async () => {
        const eventos = await carregarTiposEventos();
        this.setState({ eventosDisponiveis: eventos });
    };

    carregarFormulario = (id) => {
        api.get(`/formularios-eventos/${id}/`)
            .then(async (response) => {
                const dados = response.data;
                
                let programaObj = null;
                if (dados.programa) {
                    if (typeof dados.programa === 'object') {
                        programaObj = { value: dados.programa.id, label: dados.programa.nome };
                    } else {
                        // Se vier apenas o ID, busca os dados do programa
                        try {
                            const progResponse = await api.get(`/programas/${dados.programa}/`);
                            programaObj = { value: progResponse.data.id, label: progResponse.data.nome };
                        } catch (e) {
                            console.error("Erro ao buscar detalhes do programa", e);
                            programaObj = { value: dados.programa, label: `Programa #${dados.programa}` };
                        }
                    }
                }

                this.setState({
                    nome: dados.nome || "",
                    evento: dados.evento || "onApproveLaudo",
                    programa: programaObj,
                    titulo_modal: dados.titulo_modal || "",
                    descricao: dados.descricao || "",
                    ativo: dados.ativo !== false,
                    campos: dados.campos || [],
                    loading: false,
                });
            })
            .catch((error) => {
                console.error("Erro ao carregar formulário:", error);
                this.setState({
                    erro: "Erro ao carregar formulário",
                    loading: false,
                });
            });
    };

    carregarProgramas = (inputValue) => {
        return new Promise((resolve) => {
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
                if (this.lastResolve) this.lastResolve([]);
            }

            this.lastResolve = resolve;

            this.debounceTimer = setTimeout(async () => {
                try {
                    const response = await api.get(`/programas/?nome=${inputValue}`);
                    const options = response.data.results.map((programa) => ({
                        value: programa.id,
                        label: programa.nome,
                    }));
                    resolve(options);
                } catch (error) {
                    console.error("Erro ao carregar programas:", error);
                    resolve([]);
                }
            }, 500);
        });
    };

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({
            [name]: type === "checkbox" ? checked : value,
        });
    };

    handleProgramaChange = (selectedOption) => {
        this.setState({ programa: selectedOption });
    };

    // ===== CAMPOS =====

    handleAbrirCampoModal = (index = null) => {
        if (index !== null) {
            // Editar campo existente
            this.setState({
                showCampoModal: true,
                campoEditIndex: index,
                campoEdit: { ...this.state.campos[index] },
            });
        } else {
            // Novo campo
            this.setState({
                showCampoModal: true,
                campoEditIndex: null,
                campoEdit: this.getCampoVazio(),
            });
        }
    };

    handleFecharCampoModal = () => {
        this.setState({
            showCampoModal: false,
            campoEditIndex: null,
            campoEdit: this.getCampoVazio(),
        });
    };

    handleCampoChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState((prev) => ({
            campoEdit: {
                ...prev.campoEdit,
                [name]: type === "checkbox" ? checked : value,
            },
        }));
    };

    handleOpcoesChange = (e) => {
        const opcoesTexto = e.target.value;
        const opcoes = opcoesTexto
            .split("\n")
            .map((o) => o.trim())
            .filter((o) => o);
        this.setState((prev) => ({
            campoEdit: {
                ...prev.campoEdit,
                opcoes,
                opcoesTexto,
            },
        }));
    };

    gerarSlug = (label) => {
        return label
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9]+/g, "_")
            .replace(/^_+|_+$/g, "");
    };

    handleSalvarCampo = () => {
        const { campoEdit, campoEditIndex, campos } = this.state;

        // Validação
        if (!campoEdit.label.trim()) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: "warning",
                title: "Atenção",
                text: "O label do campo é obrigatório",
            });
            return;
        }

        // Gerar slug automaticamente se não preenchido
        if (!campoEdit.slug.trim()) {
            campoEdit.slug = this.gerarSlug(campoEdit.label);
        }

        // Verificar se precisa de opções
        const tiposComOpcoes = ["radio", "select", "checkbox"];
        if (tiposComOpcoes.includes(campoEdit.tipo) && campoEdit.opcoes.length === 0) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: "warning",
                title: "Atenção",
                text: "Este tipo de campo requer pelo menos uma opção",
            });
            return;
        }

        // Remover opcoesTexto antes de salvar
        const { opcoesTexto, ...campoLimpo } = campoEdit;

        const novosCampos = [...campos];
        if (campoEditIndex !== null) {
            novosCampos[campoEditIndex] = campoLimpo;
        } else {
            novosCampos.push(campoLimpo);
        }

        this.setState({
            campos: novosCampos,
            showCampoModal: false,
            campoEditIndex: null,
            campoEdit: this.getCampoVazio(),
        });
    };

    handleRemoverCampo = (index) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: "Remover Campo?",
            text: "Tem certeza que deseja remover este campo?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                const novosCampos = this.state.campos.filter((_, i) => i !== index);
                this.setState({ campos: novosCampos });
            }
        });
    };

    handleMoverCampo = (index, direcao) => {
        const novosCampos = [...this.state.campos];
        const novoIndex = index + direcao;

        if (novoIndex < 0 || novoIndex >= novosCampos.length) return;

        [novosCampos[index], novosCampos[novoIndex]] = [
            novosCampos[novoIndex],
            novosCampos[index],
        ];

        this.setState({ campos: novosCampos });
    };

    // ===== SALVAR =====

    handleSalvar = () => {
        const { nome, evento, programa, titulo_modal, descricao, ativo, campos, formulario_id } = this.state;

        // Validação
        if (!nome.trim()) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: "warning",
                title: "Atenção",
                text: "O nome do formulário é obrigatório",
            });
            return;
        }

        this.setState({ saving: true });

        const payload = {
            nome,
            evento,
            programa: programa?.value || null,
            titulo_modal,
            descricao,
            ativo,
            campos,
        };

        const url = formulario_id
            ? `/formularios-eventos/${formulario_id}/`
            : "/formularios-eventos/";
        const method = formulario_id ? "put" : "post";

        api({ method, url, data: payload })
            .then(() => {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: "success",
                    title: "Sucesso!",
                    text: formulario_id
                        ? "Formulário atualizado com sucesso"
                        : "Formulário criado com sucesso",
                    timer: 2000,
                    showConfirmButton: false,
                });

                this.setState({ saving: false });

                if (!formulario_id) {
                    this.props.router.navigate("/formularios-eventos");
                }
            })
            .catch((error) => {
                console.error("Erro ao salvar:", error);
                const MySwal = withReactContent(Swal);
                
                let msg = "Erro ao salvar formulário";
                if (error.response?.data?.detail) {
                    msg = error.response.data.detail;
                } else if (error.response?.data?.evento) {
                    msg = "Já existe um formulário para este evento e programa";
                }

                MySwal.fire({
                    icon: "error",
                    title: "Erro",
                    text: msg,
                });

                this.setState({ saving: false });
            });
    };

    // ===== PREVIEW =====

    handleShowPreview = () => {
        this.setState({ showPreviewModal: true });
    };

    renderPreview = () => {
        const { campos, titulo_modal, nome } = this.state;

        return (
            <Modal
                show={this.state.showPreviewModal}
                onHide={() => this.setState({ showPreviewModal: false })}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{titulo_modal || nome || "Preview do Formulário"}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    {campos.length === 0 ? (
                        <Alert variant="info">
                            Nenhum campo configurado. Adicione campos ao formulário.
                        </Alert>
                    ) : (
                        campos.map((campo, index) => (
                            <Form.Group className="mb-3" key={index}>
                                <Form.Label>
                                    {campo.label}
                                    {campo.obrigatorio && (
                                        <span className="text-danger"> *</span>
                                    )}
                                </Form.Label>

                                {campo.tipo === "text" && (
                                    <Form.Control
                                        type="text"
                                        placeholder={campo.placeholder}
                                        disabled
                                    />
                                )}

                                {campo.tipo === "textarea" && (
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder={campo.placeholder}
                                        disabled
                                    />
                                )}

                                {campo.tipo === "date" && (
                                    <Form.Control type="date" disabled />
                                )}

                                {campo.tipo === "file" && (
                                    <Form.Control
                                        type="file"
                                        accept={campo.extensoes}
                                        disabled
                                    />
                                )}

                                {campo.tipo === "select" && (
                                    <Form.Select disabled>
                                        <option value="">Selecione...</option>
                                        {campo.opcoes.map((opcao, i) => (
                                            <option key={i} value={opcao}>
                                                {opcao}
                                            </option>
                                        ))}
                                    </Form.Select>
                                )}

                                {campo.tipo === "radio" && (
                                    <div>
                                        {campo.opcoes.map((opcao, i) => (
                                            <Form.Check
                                                key={i}
                                                type="radio"
                                                label={opcao}
                                                name={campo.slug}
                                                disabled
                                            />
                                        ))}
                                    </div>
                                )}

                                {campo.tipo === "checkbox" && (
                                    <div>
                                        {campo.opcoes.map((opcao, i) => (
                                            <Form.Check
                                                key={i}
                                                type="checkbox"
                                                label={opcao}
                                                disabled
                                            />
                                        ))}
                                    </div>
                                )}

                                {campo.observacao && (
                                    <Form.Text className="text-muted">
                                        {campo.observacao}
                                    </Form.Text>
                                )}
                            </Form.Group>
                        ))
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => this.setState({ showPreviewModal: false })}
                    >
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    // ===== MODAL DE CAMPO =====

    renderCampoModal = () => {
        const { showCampoModal, campoEdit, campoEditIndex } = this.state;
        const tiposComOpcoes = ["radio", "select", "checkbox"];
        const precisaOpcoes = tiposComOpcoes.includes(campoEdit.tipo);

        return (
            <Modal show={showCampoModal} onHide={this.handleFecharCampoModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {campoEditIndex !== null ? "Editar Campo" : "Novo Campo"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={8}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Label <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="label"
                                    value={campoEdit.label}
                                    onChange={this.handleCampoChange}
                                    placeholder="Ex: Resultado do Teste"
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Slug (identificador)</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="slug"
                                    value={campoEdit.slug}
                                    onChange={this.handleCampoChange}
                                    placeholder="Auto-gerado"
                                />
                                <Form.Text className="text-muted">
                                    Deixe vazio para gerar automaticamente
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Tipo do Campo</Form.Label>
                                <Form.Select
                                    name="tipo"
                                    value={campoEdit.tipo}
                                    onChange={this.handleCampoChange}
                                >
                                    {TIPOS_CAMPOS.map((tipo) => (
                                        <option key={tipo.value} value={tipo.value}>
                                            {tipo.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group className="mb-3 mt-4">
                                <Form.Check
                                    type="checkbox"
                                    name="obrigatorio"
                                    label="Campo obrigatório"
                                    checked={campoEdit.obrigatorio}
                                    onChange={this.handleCampoChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {(campoEdit.tipo === "text" || campoEdit.tipo === "textarea") && (
                        <Form.Group className="mb-3">
                            <Form.Label>Placeholder</Form.Label>
                            <Form.Control
                                type="text"
                                name="placeholder"
                                value={campoEdit.placeholder || ""}
                                onChange={this.handleCampoChange}
                                placeholder="Texto de exemplo no campo"
                            />
                        </Form.Group>
                    )}

                    {campoEdit.tipo === "file" && (
                        <Form.Group className="mb-3">
                            <Form.Label>Extensões permitidas</Form.Label>
                            <Form.Control
                                type="text"
                                name="extensoes"
                                value={campoEdit.extensoes || ".pdf,.jpg,.jpeg,.png"}
                                onChange={this.handleCampoChange}
                                placeholder=".pdf,.jpg,.jpeg,.png"
                            />
                        </Form.Group>
                    )}

                    {precisaOpcoes && (
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Opções <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                value={campoEdit.opcoesTexto || campoEdit.opcoes?.join("\n") || ""}
                                onChange={this.handleOpcoesChange}
                                placeholder="Digite uma opção por linha:&#10;Positivo&#10;Negativo&#10;Inconclusivo"
                            />
                            <Form.Text className="text-muted">
                                Uma opção por linha
                            </Form.Text>
                        </Form.Group>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label>Observação (texto de ajuda)</Form.Label>
                        <Form.Control
                            type="text"
                            name="observacao"
                            value={campoEdit.observacao || ""}
                            onChange={this.handleCampoChange}
                            placeholder="Texto de ajuda exibido abaixo do campo"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleFecharCampoModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.handleSalvarCampo}>
                        <FaCheck className="me-1" /> Salvar Campo
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    getTipoLabel = (tipoValue) => {
        const tipo = TIPOS_CAMPOS.find((t) => t.value === tipoValue);
        return tipo ? tipo.label : tipoValue;
    };

    render() {
        const { loading, saving, titulo_pagina, erro, campos, ativo, eventosDisponiveis } = this.state;

        if (loading) {
            return (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-2">Carregando...</p>
                </div>
            );
        }

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col sm={6}>
                        <h4 className="page-title">{titulo_pagina}</h4>
                    </Col>
                    <Col sm={6} className="text-end">
                        <Button
                            variant="outline-secondary"
                            className="me-2"
                            onClick={() => this.props.router.navigate("/formularios-eventos")}
                        >
                            Voltar
                        </Button>
                        <Button
                            variant="outline-info"
                            className="me-2"
                            onClick={this.handleShowPreview}
                            disabled={campos.length === 0}
                        >
                            <FaEye className="me-1" /> Preview
                        </Button>
                        <Button variant="success" onClick={this.handleSalvar} disabled={saving}>
                            {saving ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Salvando...
                                </>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Col>
                </Row>

                {erro && (
                    <Alert variant="danger" dismissible onClose={() => this.setState({ erro: "" })}>
                        {erro}
                    </Alert>
                )}

                <Card className="cardDestaque mb-3">
                    <Card.Body>
                        <h5 className="mb-3">Dados do Formulário</h5>

                        <Row>
                            <Col sm={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Nome do Formulário <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nome"
                                        value={this.state.nome}
                                        onChange={this.handleChange}
                                        placeholder="Ex: Resultado do Teste - Raros em Foco"
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Título do Modal</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="titulo_modal"
                                        value={this.state.titulo_modal}
                                        onChange={this.handleChange}
                                        placeholder="Ex: Informe o Resultado"
                                    />
                                    <Form.Text className="text-muted">
                                        Título exibido no cabeçalho do modal
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Evento</Form.Label>
                                    <Form.Select
                                        name="evento"
                                        value={this.state.evento}
                                        onChange={this.handleChange}
                                    >
                                        {eventosDisponiveis.map((evento) => (
                                            <option key={evento.value} value={evento.value}>
                                                {evento.label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm={5}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Programa (opcional)</Form.Label>
                                    <AsyncSelect
                                        cacheOptions
                                        loadOptions={this.carregarProgramas}
                                        defaultOptions
                                        isClearable
                                        placeholder="Buscar programa..."
                                        noOptionsMessage={() => "Nenhum programa encontrado"}
                                        onChange={this.handleProgramaChange}
                                        value={this.state.programa}
                                    />
                                    <Form.Text className="text-muted">
                                        Se vazio, o formulário será global
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            <Col sm={3}>
                                <Form.Group className="mb-3 mt-4">
                                    <Form.Check
                                        type="switch"
                                        name="ativo"
                                        label={ativo ? "Ativo" : "Inativo"}
                                        checked={ativo}
                                        onChange={this.handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                name="descricao"
                                value={this.state.descricao}
                                onChange={this.handleChange}
                                placeholder="Descrição opcional do formulário"
                            />
                        </Form.Group>
                    </Card.Body>
                </Card>

                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={8}>
                                <h5 className="mb-0">Campos do Formulário</h5>
                            </Col>
                            <Col sm={4} className="text-end">
                                <Button variant="primary" onClick={() => this.handleAbrirCampoModal()}>
                                    <FaPlus className="me-1" /> Adicionar Campo
                                </Button>
                            </Col>
                        </Row>

                        {campos.length === 0 ? (
                            <Alert variant="info">
                                Nenhum campo adicionado. Clique em &quot;Adicionar Campo&quot; para começar.
                            </Alert>
                        ) : (
                            <div className="campos-list">
                                {campos.map((campo, index) => (
                                    <div
                                        key={index}
                                        className="campo-item d-flex align-items-center p-3 mb-2 border rounded"
                                        style={{ backgroundColor: "#f8f9fa" }}
                                    >
                                        <div className="me-3">
                                            <Button
                                                variant="link"
                                                size="sm"
                                                className="p-0 text-muted"
                                                onClick={() => this.handleMoverCampo(index, -1)}
                                                disabled={index === 0}
                                            >
                                                <FaArrowUp />
                                            </Button>
                                            <br />
                                            <Button
                                                variant="link"
                                                size="sm"
                                                className="p-0 text-muted"
                                                onClick={() => this.handleMoverCampo(index, 1)}
                                                disabled={index === campos.length - 1}
                                            >
                                                <FaArrowDown />
                                            </Button>
                                        </div>

                                        <div className="flex-grow-1" onClick={() => this.handleAbrirCampoModal(index)} style={{ cursor: "pointer" }}>
                                            <strong>{campo.label}</strong>
                                            <small className="text-muted ms-2">({campo.slug})</small>
                                            <div>
                                                <Badge bg="secondary" className="me-1">
                                                    {this.getTipoLabel(campo.tipo)}
                                                </Badge>
                                                {campo.obrigatorio && (
                                                    <Badge bg="danger">Obrigatório</Badge>
                                                )}
                                                {campo.opcoes?.length > 0 && (
                                                    <small className="text-muted ms-2">
                                                        {campo.opcoes.length} opção(ões)
                                                    </small>
                                                )}
                                            </div>
                                        </div>

                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => this.handleRemoverCampo(index)}
                                        >
                                            <FaTrash />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Card.Body>
                </Card>

                {this.renderCampoModal()}
                {this.renderPreview()}
            </div>
        );
    }
}

export default withRouter(FormulariosEventosEdit);
